module.exports = __webpack_public_path__ + "img/surveys-selected-icon.8fc62258.svg";